import classNames from "clsx";
import React from "react";
import Avatar from "react-avatar";
import { Card } from "@material-ui/core";
import DeviceHub from "@mui/icons-material/DeviceHub";
import FemaleIcon from "@mui/icons-material/Female";
import MaleIcon from "@mui/icons-material/Male";
import { IconButton } from "@mui/material";
import styles from "./FamilyNode.module.css";

export default function FamilyNode({
  node,
  isCurrentUser,
  isRoot,
  onSubClick,
  style,
}) {
  return (
    <div className={styles.root} style={style}>
      <div
        onClick={() => console.log(node)}
        className={classNames(isRoot && styles.isRoot)}
      >
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "15px",
              marginBottom: "10px",
              width: "100%",
              paddingLeft: "15px",
              paddingRight: "15px",
            }}
          >
            {node.firstName ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Avatar
                  name={`${node.firstName} ${node.lastName}`}
                  round={true}
                  size={44}
                />
                {node.hasSubTree && (
                  <div
                    style={{
                      backgroundColor: "white",
                      padding: "8px",
                      borderRadius: "50%",
                      height: "42px",
                      width: "42px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginLeft: "75px",
                      border: "2px solid #5B7586",
                    }}
                    onClick={() => onSubClick(node.id)}
                  >
                    <IconButton aria-label="edit" className="editbtn">
                      <DeviceHub
                        style={{
                          color: "#5B7586",
                          padding: "2px",
                        }}
                      />
                    </IconButton>
                  </div>
                )}
              </div>
            ) : null}
            {/* </div> */}
          </div>
          <Card
            variant="outlined"
            style={{
              marginTop: "-15%",
              backgroundColor: isCurrentUser
                ? "#d9ead3"
                : isRoot
                ? "#eeeeee"
                : "white",
            }}
          >
            <div
              style={{
                display: "flex",
                paddingX: "10%",
                justifyContent: "space-between",
              }}
            >
              {node.firstName ? (
                <div
                  className={styles.textend}
                  style={{ padding: "24px", paddingTop: "30px" }}
                >
                  <div
                    className={styles.name}
                  >{`${node.firstName} ${node.lastName}`}</div>
                  <div className={styles.dates}>{node.userCode}</div>
                </div>
              ) : null}

              {node.firstName ? null : (
                <div className={styles.family_container}>
                  <div className={styles.family_name}>{"Family"}</div>
                </div>
              )}

              {node.gender ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: "8px",
                    padding: "8px",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "white",
                      padding: "8px",
                      borderRadius: "50%",
                    }}
                  >
                    {node.gender === "Male" ? (
                      <MaleIcon
                        style={{
                          color: "#a4ecff",
                        }}
                      />
                    ) : (
                      <FemaleIcon
                        style={{
                          color: "#fdaed8",
                        }}
                      />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}
